export default __webpack_public_path__ + "static/media/kyc-selfie-illustration-bad-en.f0c83477.svg";